// ── Parser de CSV (sem dependência externa) ───────────────────────
// Robusto o suficiente para planilhas exportadas por Google Sheets / Excel:
// campos entre aspas, vírgulas e quebras de linha DENTRO de aspas, aspas
// escapadas ("" → "), CRLF e BOM. O separador é vírgula (padrão do modelo).

export interface ParsedCsv {
  headers: string[];
  rows: Record<string, string>[];
}

// Quebra o texto em matriz de células respeitando aspas.
const toMatrix = (text: string): string[][] => {
  // Remove BOM se presente.
  const src = text.charCodeAt(0) === 0xfeff ? text.slice(1) : text;
  const rows: string[][] = [];
  let row: string[] = [];
  let field = '';
  let inQuotes = false;

  for (let i = 0; i < src.length; i++) {
    const c = src[i];
    if (inQuotes) {
      if (c === '"') {
        if (src[i + 1] === '"') { field += '"'; i++; } // aspa escapada
        else inQuotes = false;
      } else {
        field += c;
      }
    } else if (c === '"') {
      inQuotes = true;
    } else if (c === ',') {
      row.push(field); field = '';
    } else if (c === '\n') {
      row.push(field); rows.push(row); row = []; field = '';
    } else if (c === '\r') {
      // ignora — \r\n é tratado pelo \n; \r solitário não separa linha
    } else {
      field += c;
    }
  }
  // Último campo/linha (arquivo pode não terminar em \n).
  if (field !== '' || row.length > 0) { row.push(field); rows.push(row); }
  return rows;
};

// Converte o CSV em { headers, rows } com cada linha indexada pelo cabeçalho.
// Linhas totalmente vazias são descartadas.
export const parseCsv = (text: string): ParsedCsv => {
  const matrix = toMatrix(text).filter(r => r.some(c => c.trim() !== ''));
  if (matrix.length === 0) return { headers: [], rows: [] };

  const headers = matrix[0].map(h => h.trim());
  const rows = matrix.slice(1).map(cols => {
    const obj: Record<string, string> = {};
    headers.forEach((h, i) => { obj[h] = (cols[i] ?? '').trim(); });
    return obj;
  });
  return { headers, rows };
};
